// Adapted from https://github.com/T-vK/DynamicQuillTools
class QuillToolbarItem {
    constructor(options) {
      const me = this
      me.options = options
  
      me.qlFormatsEl = document.createElement("span")
      me.qlFormatsEl.className = "ql-formats"
    }
    /**
     * Attaches this tool to the given Quill Editor instance.
     *
     * @param {Quill} quill - The Quill Editor instance that this tool should get added to.
     */
    attach(quill, tooltip) {
      const me = this
      me.quill = quill
      // me.toolbar = quill.getModule('toolbar')
      // me.toolbarEl = me.toolbar.container
      // debugger
      tooltip.root.querySelector('.ql-toolbar').appendChild(me.qlFormatsEl) 
    }
    /**
     * Detaches this tool from the given Quill Editor instance.
     *
     * @param {Quill} quill - The Quill Editor instance that this tool should get added to.
     */
    detach(quill) {
      const me = this
      me.toolbarEl.removeChild(me.qlFormatsEl)
    }
    /**
     * Calculate the width of text.
     *
     * @param {string} text - The text of which the length should be calculated.
     * @param {string} [font="500 14px 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"] - The font css that shuold be applied to the text before calculating the width.
     */
    _getTextWidth(text, font="500 14px 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif") {
      const canvas = this._getTextWidth.canvas || (this._getTextWidth.canvas = document.createElement("canvas"))
      const context = canvas.getContext("2d")
      context.font = font
      const metrics = context.measureText(text)
      return metrics.width
    }
    /**
     * Add a global css rule to the document.
     *
     * @param {string} cssRule - CSS rules
     */
    _addCssRule(cssRule) {
      const style = document.createElement("style");
      document.head.appendChild(style);
      style.sheet.insertRule(cssRule, 0)
    }
    /**
     * Generate a random ID.
     *
     * @returns {string} random 10 digit ID
     */
    _generateId() {
      return Math.random().toString().substr(2, 10)
    }
    }
  
  
  
    /** @class Class representing a button tool for a Quill Editor toolbar. */
    class QuillToolbarButton extends QuillToolbarItem {
        
    /**
     * Creates an instance of QuillToolbarButton.
     *
     * @constructor
     * @param {object} [options] - The options/settings for this QuillToolbarButton.
     * @param {string} [options.id=`button-${random10digitNumber}`] - The id of the quill tool.
     * @param {string} [options.value] - The default hidden value of the button.
     * @param {string} options.icon - The default icon this button tool will have.
     */
    constructor(options) {
      super(options)
      const me = this
  
      me.id = me.options.id || `button-${me._generateId()}`
  
      me.qlButton = document.createElement("button")
      me.qlButton.className = `ql-${me.id}`
      me.setValue(me.options.value)
      me.setIcon(me.options.icon)
      me.qlButton.onclick = function() {
        me.onClick(me.quill)
      }
      me.qlFormatsEl.appendChild(me.qlButton)
    }
    /**
     * Set the icon for this button tool.
     *
     * @param {string} newLabel - The <svg> or <img> html tag to use as an icon. (Make sure it's 18x18 in size.)
     */
    setIcon(imageHtml) {
      const me = this
      me.qlButton.innerHTML = imageHtml
    }
    /**
     * Set the hidden value of this button tool.
     *
     * @param {string} newLabel - The <svg> or <img> html tag to use as an icon. (Make sure it's 18x18 in size.)
     */
    setValue(value) {
      const me = this
      me.qlButton.value = value
    }
    /**
     * Set the hidden value of this button tool.
     *
     * @param {string} newLabel - The <svg> or <img> html tag to use as an icon. (Make sure it's 18x18 in size.)
     */
    getValue() {
      const me = this
      return me.qlButton.value
    }
    /**
     * A callback that gets called automatically when the button is clicked, tapped or triggered witht he keyboard etc. This callback is expected to be overwritten.
     *
     * @param {Quill} quill - The quill instance the dropdown tool is attached to.
     */
    onClick(button, quill) {
  
    }
  }
  
  export { QuillToolbarButton };